import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getLoginToken } from '../../../../utils/storageUtils'
import { convertToEasternISO, formatDateYMD, getDateDaysAgo } from '../../../../utils/dateFormatter'
import { getKPISummaryStart } from '../../../../store/redux-slices/dashboard'
import useDidMountEffect from '../../../../utils/useDidMountEffect'

const useKPISummary = ({ selectedPortal, selectedClient }) => {
  const dispatch = useDispatch()
  const { kpiSummeryLoading: loading, KPISummary } = useSelector((state) => state.dashboard)
  const [selectedTab, setSelectedTab] = useState('casino')
  const [dateOptions, setDateOptions] = useState('')
  const [search, setSearch] = useState('')
  const [state, setState] = useState([
    {
      startDate: getDateDaysAgo(0),
      endDate: new Date(),
      key: 'selection'
    }
  ])
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(20)
  const isInitialRender = useDidMountEffect()
  const totalPages = Math.ceil(KPISummary?.count / limit)

  const loadKPISummary = (data) => {
    const startDate = convertToEasternISO(data?.action === 'refresh' ? getDateDaysAgo(0) : state.map(a => a.startDate))
    const endDate = convertToEasternISO(data?.action === 'refresh' ? new Date() : state.map(a => a.endDate))
    const searchString = data?.action === 'refresh' ? '' : search
    const date_options = data?.action === 'refresh' ? '' : dateOptions

    dispatch(getKPISummaryStart({
      isTenant: false,
      startDate,
      endDate,
      tenantId: selectedPortal,
      adminId: selectedClient,
      type: selectedTab,
      search: searchString,
      dateOptions: date_options,
      page,
      limit
    }))
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          loadKPISummary()
        } else {
          setPage(1)
        }
      }
    }, 1000)
    return () => clearTimeout(delayDebounceFn)
  }, [state, selectedClient, selectedPortal, selectedTab, dateOptions, search, limit])

  useEffect(() => {
    if (!isInitialRender) loadKPISummary()
  }, [page])

  useEffect(() => {
    loadKPISummary()
  }, [])

  const getCsvDownloadUrl = () =>
    `${process.env.REACT_APP_API_URL}/api/admin/casino/bonus-report?search=${search}&date=${dateOptions}&csvDownload=true&token=${getLoginToken()}`

  // const handleResetFilters = useCallback(() => {
  //   setSearch('')
  //   setDateOptions('')

  //   loadKPISummary({ action: 'refresh' })
  // }, [])
  const handleResetFilters = useCallback(() => {
    search !== "" && setSearch('')
    dateOptions !== "" && setDateOptions('')
    if (search === "" && dateOptions === "") {
      loadKPISummary({ action: 'refresh' })

    }
  }, [search, dateOptions])


  return {
    loadKPISummary,
    loading,
    setState,
    state,
    getCsvDownloadUrl,
    KPISummary,
    selectedTab,
    setSelectedTab,
    search,
    setSearch,
    dateOptions,
    setDateOptions,
    limit,
    setLimit,
    page,
    setPage,
    totalPages,
    handleResetFilters
  }
}

export default useKPISummary
